import React from 'react';
import { Heading, Text } from '@aws-amplify/ui-react';
import { useWhatsAppMode } from '../../../hooks/useWhatsAppMode';
import TabNavigation from '../shared/TabNavigation';

export const WhatsAppAuthHeader = () => {
  const [mode] = useWhatsAppMode();

  return (
    <div>
      <Heading level={3} padding="32px 0 8px 0" textAlign="center">
        {mode === 'signUp' ? 'Create your account' : 'WhatsApp Sign In'}
      </Heading>
      <Text
        textAlign="center"
        color="var(--amplify-colors-font-tertiary)"
        fontSize="14px"
        marginBottom="24px"
      >
        {mode === 'signUp' ? 'Get started with Prodyt WhatsApp' : 'Connect your WhatsApp account'}
      </Text>

      <TabNavigation />
    </div>
  );
};

export default WhatsAppAuthHeader;
